const isShowPrev = (totalImg, currentIdx) => totalImg > 5 && currentIdx >= 4
const isShowNext = (totalImg, currentIdx) =>
  totalImg > 5 && currentIdx !== totalImg - 1

// relate with design
// if total image is less than or equal 5, max number of thumbnails will show as 5
// if total image more than 5, max number of thumbnails will show as 4 with arrow
const getMaxThumbnails = (totalImg) => (totalImg <= 5 ? 5 : 4)

export { isShowPrev, isShowNext, getMaxThumbnails }
